/**
 * Reading an uploaded text file in the browser: the allocation-plan import
 * (W2-3) and "Organisationen importieren" (plan docs/plans/organization-import.md
 * §5.1). The server reads the text; the bytes are decoded here.
 */

/**
 * The file's text. UTF-8 first; a file that is not valid UTF-8 is read as
 * Windows-1252, which is what German Excel writes for "CSV (Trennzeichen-getrennt)".
 */
export const decodeTextFile = (buffer: ArrayBuffer): string => {
    try {
        return new TextDecoder('utf-8', { fatal: true }).decode(buffer);
    } catch {
        return new TextDecoder('windows-1252').decode(buffer);
    }
};

export const readTextFile = (file: Blob): Promise<string> => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(decodeTextFile(reader.result as ArrayBuffer));
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(file);
});
